import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Divider, Drawer, IconButton, Typography } from '@mui/material';
import { DrawerHeader, drawerWidth } from './drawer-configuration';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CopyCPTCodeDescription from './sections/code-description';

type Props = {
  open: boolean;
  handleDrawerClose: React.MouseEventHandler<HTMLButtonElement>;
  source: 'under_eoc' | 'under_screening' | 'under_dsn';
};

type Dimensions = {
  [key in Props['source']]: {
    marginTop: string;
  };
};

const dimensions: Dimensions = {
  under_eoc: {
    marginTop: '10%',
  },
  under_screening: {
    marginTop: '0',
  },
  under_dsn: {
    marginTop: '12%',
  },
};

const CopyTextBank = (props: Props) => {
  const { open, handleDrawerClose, source } = props;
  const theme = useTheme();

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          marginTop: dimensions[source].marginTop,
          border: '1px solid #E5E7EB',
          borderRadius: '10px'
        },
      }}
      variant="persistent"
      anchor="right"
      open={open}
    >
      <DrawerHeader>
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
        <Typography variant="h6">Copy Text Bank</Typography>
      </DrawerHeader>
      <Divider />

      {/* Sections */}
      <CopyCPTCodeDescription />
    </Drawer>
  );
};

export default CopyTextBank;
